import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";
import Axios from "../../../axios/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Supplier.css";
import { useLocation } from 'react-router-dom';

function ProductReports() {
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [fastMoving, setFastMoving] = useState([]);
  const [slowMoving, setSlowMoving] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

useEffect(() => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
}, [location]);


  useEffect(() => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);

const config = {
  headers: {
    "x-supplier-id": supplierInfo.supplierId,
  },
};
      // Fetch Fast Moving Products
      Axios.get("/supplier/fast-moving", config)
        .then((res) => setFastMoving(res.data))
        .catch((err) =>
          console.error("Error fetching fast moving products:", err)
        );

      // Fetch Slow Moving Products
      Axios.get("/supplier/slow-moving", config)
        .then((res) => setSlowMoving(res.data))
        .catch((err) =>
          console.error("Error fetching slow moving products:", err)
        );
    }
  }, []);

  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
                                        <SupplierSidebar closeSidebar={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }} />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h2 className="dashboard-title mb-4">Product Reports</h2>
              <div className="row g-4">
                {/* Fast Moving Products Card */}
                <div className="col-md-6">
                  <div className="enhanced-card p-4 text-center">
                    <div className="card-icon-wrapper card-icon-success">
                      <i className="bi bi-rocket-takeoff fs-2"></i>
                    </div>
                    <h6 className="text-muted">Fast Moving Products</h6>
                    <ul className="list-group mt-2">
                      {fastMoving.length > 0 ? (
                        fastMoving.slice(0, 4).map((product, i) => (
                          <li key={i} className="list-group-item small">
                            {product.productName} - Sold:{" "}
                            {product.totalQuantity} ({product.totalSales})
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item text-muted small">
                          No data available
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                {/* Slow Moving Products Card */}
                <div className="col-md-6">
                  <div className="enhanced-card p-4 text-center">
                    <div className="card-icon-wrapper card-icon-warning">
                      <i className="bi bi-hourglass-bottom fs-2"></i>
                    </div>
                    <h6 className="text-muted">Slow Moving Products</h6>
                    <ul className="list-group mt-2">
                      {slowMoving.length > 0 ? (
                        slowMoving.slice(0, 4).map((product, i) => (
                          <li key={i} className="list-group-item small">
                            {product.productName} - Sold:{" "}
                            {product.totalQuantity} ({product.totalSales})
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item text-muted small">
                          No data available
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductReports;
